import { throwUnsupportedRuntimeError } from "../error.ts";
async function run(script, args, options) {
    void script, args, options;
    throwUnsupportedRuntimeError();
}
(function (run) {
    run.maxWorkers = undefined;
})(run || (run = {}));
export default run;
//# sourceMappingURL=run.js.map